module.exports = __webpack_public_path__ + "static/media/pin_atrativos.76df8a1b.png";